function getKey(item) {
  try {
    return [
      ((item.article.authors || [])[0] || '').split(/[\s]+/).pop(),
      (item.article.year || ''),
      (item.article.title || '').split(/[,\.\s]+/)
        .filter(part => part && /^[a-z0-9]/i.test(part))[0]
    ].join('').toLowerCase();
  } catch (e) {
    let id = '';
    let ext_ids = item.ext_ids || {};
    if (!id) id = ext_ids.doi;
    if (!id) id = ext_ids.pmcid;
    if (!id) id = ext_ids.pmid;
    if (!id) id = ext_ids[Object.keys(ext_ids)[0]];
    return (id || '').replace(/[\W]+/g, '');
  }
}

function downloadFilename(item, suffix) {
  let name = getKey(item);
  if (!name) return suffix;
  if (article.data.index != undefined) {
    name += `-supplement(${article.data.index + 1})`;
  }
  return name + '-' + suffix;
}

module.exports = {
  getKey,
  downloadFilename
};
